import React, { Fragment, useState } from "react";
import { useDispatch } from 'react-redux';
import { getAllComplaints } from '../../../actions/complaintActions';
import { makeStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Alert from '@material-ui/lab/Alert';
import Snackbar from '@material-ui/core/Snackbar';
import { CircularProgress } from "@material-ui/core"
import { useTranslation } from 'react-i18next';
import { showAlertSnackbar } from '../../../reducers/uiSlice';

const useStyles = makeStyles((theme) => ({
    containerStyle: { 
        display: "flex", 
        alignItems: "center",
        marginTop: 10
    },
    spanStyle: { 
        display: "inline-block", 
        padding: '0 20px', 
        paddingTop: '5px' 
    },
    textFieldStyle: { 
        marginLeft: '20px', 
        width: 100 
    },
    buttonStyle: { 
        padding: '10px 10px', 
        marginLeft: 20 
    },
    titleSize: { 
        marginTop: 20, 
        fontSize: '1.4rem' 
    }
}));

const moment = require('moment');

function SearchDate(props) {
    const {t} = useTranslation('complaint');
    const classes = useStyles();
    const dispatch = useDispatch();

    const [dateFrom, setDateFrom] = useState(moment().format('YYYY-MM-DD'));
    const [dateTo, setDateTo] = useState(moment().format('YYYY-MM-DD'));
    const [loading, setLoading] = useState(false);
    const [disable, setDisable] = useState(false);

    const handleSearch = (dateFrom, dateTo) => {
        setLoading(true);
        setDisable(true);
        props.handleChange(false);
        const dateFromNum = moment(dateFrom).startOf('day').valueOf() / 1000;
        const dateToNum = Math.floor(moment(dateTo).endOf('day').valueOf() / 1000);
        props.handleFirst();
        dispatch(getAllComplaints(dateFromNum, dateToNum))
        .then(() => {            
            props.handleChange(true);
            setLoading(false);
            setDisable(false);
        })
        .catch(() => {
            setLoading(false);
            setDisable(false);
        })
    }
    const handle3Days = () => {
        setDateFrom(moment().subtract(29, 'd').format('YYYY-MM-DD'));
        setDateTo(moment().format('YYYY-MM-DD'));
    };
    const handle7Days = () => {
        setDateFrom(moment().subtract(59, 'd').format('YYYY-MM-DD'));
        setDateTo(moment().format('YYYY-MM-DD'));
    };
    const handle1Month = () => {
        setDateFrom(moment().subtract(89, 'd').format('YYYY-MM-DD'));
        setDateTo(moment().format('YYYY-MM-DD'));
    };

    return (
        <Fragment>
            <Grid container className={classes.containerStyle}>
                <div style={{ marginRight: 10 }}>{t('date')}</div>
                <TextField 
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateFrom}
                    onChange={(e)=>setDateFrom(e.target.value)}
                />
                <span className={classes.spanStyle}>{t('to')}</span>
                <TextField 
                    size="small"
                    id="searchStartDate"
                    type="date"
                    variant="outlined"
                    value={dateTo}
                    onChange={handleDateTo}
                />
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={() => handleSearch(dateFrom, dateTo)}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('search')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={handle3Days}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('last_thirty_days')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={handle7Days}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('last_sixty_days')}
                </Button>
                <Button
                    variant="contained"
                    color="primary"
                    size="small"
                    onClick={handle1Month}
                    className={classes.buttonStyle}
                    disabled={disable}
                >
                    {t('last_ninety_days')}
                </Button>
                {
                    loading &&
                    <div className={classes.buttonStyle}>
                        <CircularProgress color='secondary'/>
                    </div>
                }
            </Grid>
        </Fragment>
    );

    function handleDateTo(event){
        const dateToTamp = moment(event.target.value).unix();
        const dateFromTamp = moment(dateFrom).unix();
        if (dateToTamp < dateFromTamp)  {
            setDateTo(dateFrom);
            dispatch(showAlertSnackbar({message: 'End date must be later than start date!', type: 'warning'}))
        } else {
            setDateTo(event.target.value);
        }
    }
}

export default SearchDate;